import DPO from 'dpo8core';
import { checkOptionFromLocalStorage } from '@app/utils/utils';

const measurementParser = {
  imperial: 'inches',
  metric: 'millimeters',
};

export const getLocale = measurement => measurementParser[measurement] || measurement;

export const inchesToTwips = value => {
  const converter = new DPO.text.UnitConverter();
  return value
    ? +converter.convert(value).from('inch').to('twip', {
        label: false,
        transform: 'round',
        transformValue: 4,
      })
    : value;
};

export const mmToTwips = value => {
  const converter = new DPO.text.UnitConverter();
  return value
    ? +converter.convert(value).from('mm').to('twip', {
        label: false,
        transform: 'round',
        transformValue: 4,
      })
    : value;
};

export const fromTwips = (value, measurement) => {
  const locale = getLocale(measurement);
  const converter = new DPO.text.UnitConverter();
  return (
    +converter.convert(value).from('twip').to(locale, {
      label: false,
      transform: 'round',
      transformValue: 4,
    }) || 0
  );
};

export const toTwips = (value, measurement) => {
  const locale = getLocale(measurement);
  const converter = new DPO.text.UnitConverter();
  return (
    +converter.convert(value).from(locale).to('twip', {
      label: false,
      transform: 'round',
      transformValue: 4,
    }) || 0
  );
};

export const twipsPerPixel = ppi => inchesToTwips(1) / ppi;

export const getCurrentMeasurementLocale = ({ locale: { measurementSystem } }) => {
  const localStorageKey = 'avery.fau.measurement';

  return checkOptionFromLocalStorage(localStorageKey, getLocale(measurementSystem));
};